var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrowser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Browser__Icn/40px/Browser",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Browser__Color/Transp_00",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Browser__Rectangle"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20,8 C26.627417,8 32,13.372583 32,20 C32,26.627417 26.627417,32 20,32 C13.372583,32 8,26.627417 8,20 C8,13.372583 13.372583,8 20,8 Z M19.000152,29.7698008 L19,21.499 L15.0598087,21.4993948 C15.3966922,25.6841761 17.109821,28.9048653 19.000152,29.7698008 Z M21,21.5 L21.000849,29.7693425 C22.8906338,28.903797 24.6030955,25.6839485 24.9401111,21.500391 L21,21.5 Z M15.2370403,28.7950272 L15.1150786,28.5949839 C14.0069389,26.743824 13.2554786,24.2681985 13.0541364,21.4997168 L10.1117443,21.4999594 C10.5865077,24.6562332 12.5364391,27.3294219 15.2370403,28.7950272 Z M24.7627034,28.7943151 L24.8956986,28.7216792 C27.5270682,27.2414511 29.4208992,24.6048496 29.8881049,21.5009613 L26.9457908,21.5007167 C26.7370186,24.3694026 25.9375798,26.9235901 24.7627034,28.7943151 Z M24.7629597,11.2049728 L24.8849214,11.4050161 C26.1248649,13.4763558 26.9182351,16.3295451 26.9940342,19.5000165 L29.9877141,19.4999314 C29.8110637,15.9130082 27.7444991,12.8230422 24.7629597,11.2049728 Z M21.000849,10.2306575 L21,19.5 L24.9934185,19.4999789 C24.8703354,14.8350257 23.0386905,11.1640149 21.000849,10.2306575 Z M15.0066079,19.4989782 L19,19.499 L19.000152,10.2301992 C16.9620551,11.1627461 15.1299467,14.8337369 15.0066079,19.4989782 Z M15.2372966,11.2056849 L15.1043014,11.2783208 C12.1945755,12.9151331 10.1866807,15.9659099 10.0123351,19.4989335 L13.0059897,19.4990176 C13.0843983,16.2259762 13.9275601,13.2911443 15.2372966,11.2056849 Z",
    id: ".._.._src_svg_Icn_40px_Browser__Combined-Shape"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowser);
export default __webpack_public_path__ + "static/media/Browser.d2c5cf3485a66a0fcc0ba4fb06d9edeb.svg";
export { ForwardRef as ReactComponent };